import { reduxForm } from 'redux-form';

import ClientMembershipForm from './ClientMembershipForm';

export default reduxForm({ form: 'addClientForm' })(ClientMembershipForm as any) as any;
